<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('podcasts')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Season</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            placeholder="Title"
            :rules="{ required: true }"
            v-model="podcast_data.name"
          >
          </base-input>
        </div>
        <div class="mb-4">
          <!-- <p class="input-title text-black">Description</p>
          <base-input
            alternative
            class="mb-3"
            name="Description"
            :rules="{ required: true }"
            placeholder="Description"
            v-model="podcast_data.description"
          >
          </base-input> -->
          <b-form-group label="Description">
            <quill-editor
              v-model="podcast_data.description"
              :options="editorOption"
              class="quill-h200px my-2"
            />
          </b-form-group>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Category</p>
          <b-form-select
            v-model="podcast_data.categoryId._id"
            placeholder="Select"
            class="w-full"
            required
          >
            <b-form-select-option
              v-for="item in getAllCategory.result"
              class="py-5"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            >
            </b-form-select-option>
          </b-form-select>
        </div>
        <!-- <base-input
          alternative
          class="mb-3 mt-3"
          name="link"
          :rules="{
            required: true,
            regex:
              '(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?',
          }"
          placeholder="Enter URL"
          v-model="blog_data.link"
        >
        </base-input>

        <p class="font-semibold mt-6 mb-2 text-xl">Upload Image</p>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        (Dimensions should H-700, W-900)
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>

        <img v-if="image" :src="image" ref="cover" />
        <p class="py-4">Uploaded Image</p>
        <img :src="$imageURL + '/' + blog_data.image" alt="uploaded-image" /> -->
        <!-- <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

        <!-- <div class="mb-2">
          <b-form-group label="Tags:" class="my-4">
            <div class="md:flex justify-between items-center">
              <b-form-select
                v-model="blog_data.tags[0]"
                required
                class="mr-4 lg:mb-0 md:mb-0 mb-4"
              >
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select
                v-model="blog_data.tags[1]"
                class="mr-4 lg:mb-0 md:mb-0 mb-4"
              >
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="blog_data.tags[2]" class="">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              >
            </div>
          </b-form-group>
        </div>

        <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="onlyRegistered">
            <p>
              <strong>
                <p class="col-blk">
                  Click here to restrict access to this podcast for registered
                  users only.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!onlyRegistered ? true : false"
          >
          </multiselect>
        </div> -->
        <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="podcast_data.metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="podcast_data.metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="podcast_data.metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="podcast_data.metaKeyword"
            >
            </base-input>
          </div>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      episodes: [],
      // image: null,
      // coverImage: "",
      // file1: "",
      // filter1: [],
      // filter2: [],
      // filter3: [],
      // Ctags: [],
      // selectedPageCategory: null,
      editorOption: {
        theme: "snow",
      },
      title: "",
      category: "",
      pageData: {},
      podcast_data: {},
      // imageErr: false,
      // msg: {},
      // selectedMembership: null,
      // membershipFilter: [],
      // onlyRegistered: false,
    };
  },
  computed: {
    // ...mapState("cms", {
    //   selectedBlog: "selectedBlog",
    //   filtertags: "filtertags",
    //   filters: "filters",
    //   selectedpagecategory: "selectedpagecategory",
    // }),
    // ...mapState("subscribe", {
    //   get_all_membership: "get_all_membership",
    // }),
    ...mapState("podcast", {
      selectedPodcast: "selectedPodcast",
      getAllCategory: "getAllCategory",
    }),
  },
  watch: {
    pageData(val) {
      this.podcast_data = { ...val };
      // this.gettagsbycategory(this.blog_data.pageCategory);
    },
    // membershipFilter() {
    //   if (this.blog_data.memberships && this.blog_data.memberships.length > 0) {
    //     this.selectedMembership = this.membershipFilter.filter((membership) => {
    //       let data = this.blog_data.memberships.find(
    //         (member) => member._id === membership._id
    //       );
    //       // return this.blog_data.memberships.includes(membership._id);
    //       return data;
    //     });
    //     // console.log(this.selectedMembership);
    //   }
    // },
  },
  methods: {
    // handleSuccess(image) {
    //   this.imageErr = false;
    //   if (!image.type.includes("image")) {
    //     this.imageErr = true;
    //     this.msg.image = "Upload Image Only";
    //   } else {
    //     this.imageErr = false;
    //     let mByte = 5 * 1048576;
    //     if (image.size > mByte) {
    //       this.$swal.fire({
    //         title: "File size exceeds the allowed limit!",

    //         html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
    //         confirmButtonText: "Okay",
    //         icon: "warning",
    //         confirmButtonColor: "#830c81",
    //         showCancelButton: false,
    //       });
    //       return;
    //     }
    //     this.coverImage = image;
    //     this.readerData(image);
    //   }
    // },

    handleSuccess(image) {
      console.log(image);

      this.imageErr = false;

      if (!image.type.startsWith("image/")) {
        this.$swal.fire({
          title: "Invalid File",
          text: "Please upload an image file only!",
          // html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          icon: "error",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          text: "Please ensure that the file size does not exceed 5MB",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      this.coverImage = image;
      this.readerData(image);
    },
    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    // async onSubmit() {
    //   if (!this.onlyRegistered) {
    //     this.selectedMembership = null;
    //   }
    //   let FormData = require("form-data");
    //   let data = new FormData();
    //   this.Ctags.push(
    //     this.blog_data.tags[0],
    //     this.blog_data.tags[1],
    //     this.blog_data.tags[2]
    //   );
    //   data.append("_id", this.blog_data._id);
    //   data.append("title", this.blog_data.title);
    //   data.append("media", this.coverImage);
    //   data.append("link", this.blog_data.link);
    //   data.append("html", this.blog_data.html);
    //   data.append("pageCategory", this.blog_data.pageCategory);
    //   data.append("tags", JSON.stringify(_.uniq(this.Ctags)));

    //   data.append("metaKeyword", this.blog_data.metaKeyword);
    //   data.append("metaCanonicalTag", this.blog_data.metaCanonicalTag);
    //   data.append("metaDesc", this.blog_data.metaDesc);
    //   data.append("metaTitle", this.blog_data.metaTitle);

    //   data.append("memberships", JSON.stringify(this.selectedMembership));
    //   if (this.selectedMembership !== null) {
    //     data.append("onlySubscribed", true);
    //     data.append("onlyRegistered", true);
    //   } else {
    //     data.append("onlySubscribed", false);
    //     data.append("onlyRegistered", this.onlyRegistered);
    //   }
    //   let loader = this.$loading();
    //   try {
    //     const editData = await this.$store.dispatch("cms/editPage", data);
    //     if (editData.code == 200) {
    //       this.$router.push({ name: "podcasts" });
    //       this.$swal.fire({
    //         text: "Podcast successfully updated!",
    //         icon: "success",
    //         confirmButtonText: "Okay",
    //         confirmButtonColor: "#830c81",
    //         showCancelButton: false,
    //       });
    //       loader.close();
    //     }
    //   } catch (error) {
    //     if (error) {
    //       loader.close();
    //     }
    //   }
    // },
    async onSubmit() {
      if (!this.podcast_data.description) {
        this.$notify.error({
          message: "Description is required",
          position: "top-right",
        });
        return;
      }
      let payload = {
        podcastId: this.podcast_data._id,
        name: this.podcast_data.name,
        description: this.podcast_data.description,
        categoryId: this.podcast_data.categoryId,

        metaTitle: this.podcast_data.metaTitle,
        metaCanonicalTag: this.podcast_data.metaCanonicalTag,
        metaDesc: this.podcast_data.metaDesc,
        metaKeyword: this.podcast_data.metaKeyword,
      };

      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "podcast/update_podcast",
          payload
        );
        this.$router.push({ name: "podcasts" });
        this.$swal.fire({
          text: "Your podcast has been successfully edited",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        console.log(error);
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedPodcast;
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
    // this.gettagsbycategory();
  },
};
</script>
